import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SignOut, UserCircle, House, QrCode } from '@phosphor-icons/react';

export const DashboardNav = ({ userName, onLogout }) => {
  const navigate = useNavigate();
  return (
    <nav className="bg-[#0A0A0A]/80 backdrop-blur-xl border-b border-white/5 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-14 sm:h-16">
          <button onClick={() => navigate('/dashboard')} className="flex items-center gap-2 sm:gap-3 hover:opacity-80 transition-opacity" data-testid="home-btn">
            <img
              src="https://customer-assets.emergentagent.com/job_2decf1d9-6688-4b47-98c1-1893beae897a/artifacts/lr28yf8y_43425DE4-4AE4-4784-89F6-4AA746534747.png"
              alt="Show Master"
              className="h-12 w-12 sm:h-[60px] sm:w-[60px]"
            />
            <span className="text-base sm:text-xl font-black text-white" style={{fontFamily: 'Outfit'}}>SHOW MASTER</span>
          </button>
          <div className="flex items-center gap-2 sm:gap-4">
            <span className="text-[#9E9E9E] text-xs sm:text-sm hidden sm:inline">{userName}</span>
            <button
              data-testid="nav-home-btn"
              onClick={() => navigate('/dashboard')}
              className="p-2 text-[#9E9E9E] hover:text-[#0096FF] transition-colors"
              title="Home"
            >
              <House size={22} weight="duotone" />
            </button>
            <button
              data-testid="nav-qr-btn"
              onClick={() => navigate('/qr-code')}
              className="p-2 text-[#9E9E9E] hover:text-[#FACC15] transition-colors"
              title="Site QR Code"
            >
              <QrCode size={22} weight="duotone" />
            </button>
            <button
              data-testid="profile-btn"
              onClick={() => navigate('/profile')}
              className="p-2 text-[#9E9E9E] hover:text-[#0096FF] transition-colors"
              title="My Profile"
            >
              <UserCircle size={22} weight="duotone" />
            </button>
            <button
              data-testid="logout-btn"
              onClick={onLogout}
              className="p-2 text-[#9E9E9E] hover:text-white transition-colors"
            >
              <SignOut size={20} weight="duotone" />
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};
